(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["marine-hero-cards"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('marine-hero-cards')) {
    class MarineHeroCards extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.marine-hero-cards__track');
        this.dotsWrap = this.querySelector('.marine-hero-cards__dots');
        this.slides = Array.from(this.track.children).filter((el) => el.classList.contains('marine-hero-card')).slice(0, 6);
        this.index = 0;
        if (this.slides.length < 2) return;

        this.buildDots();
        this.observeSlides();

        this.desktop = window.matchMedia('(min-width: 750px)');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.paused = false;
        this.addEventListener('mouseenter', () => this.pause());
        this.addEventListener('mouseleave', () => this.resume());
        this.addEventListener('focusin', () => this.pause());
        this.addEventListener('focusout', () => this.resume());
        this.addEventListener('shopify:block:select', (event) => this.onBlockSelect(event));
        this.addEventListener('shopify:block:deselect', () => this.resume());
        this.desktop.addEventListener('change', () => this.restart());
        this.firstChangePending = true;
        this.restart();
      }

      disconnectedCallback() {
        this.stop();
        if (this.observer) this.observer.disconnect();
      }

      buildDots() {
        if (!this.dotsWrap) return;
        const label = this.dataset.dotLabel || '';
        this.dots = this.slides.map((slide, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'marine-hero-cards__dot';
          dot.setAttribute('aria-label', `${label} ${i + 1}`);
          dot.addEventListener('click', () => {
            this.goTo(i);
            this.restart();
          });
          this.dotsWrap.appendChild(dot);
          return dot;
        });
        this.dotsWrap.hidden = false;
        this.setActive(0);
      }

      observeSlides() {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
                this.setActive(this.slides.indexOf(entry.target));
              }
            });
          },
          { root: this.track, threshold: [0.6] }
        );
        this.slides.forEach((slide) => this.observer.observe(slide));
      }

      setActive(i) {
        if (i < 0) return;
        this.index = i;
        if (this.dots) this.dots.forEach((dot, d) => dot.setAttribute('aria-current', d === i ? 'true' : 'false'));
      }

      goTo(i) {
        const slide = this.slides[i];
        if (!slide) return;
        this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
        this.setActive(i);
      }

      next() {
        this.goTo((this.index + 1) % this.slides.length);
      }

      canAutoplay() {
        return this.dataset.autoplay === 'true' && this.desktop.matches && !this.reducedMotion.matches;
      }

      restart() {
        this.stop();
        if (!this.canAutoplay() || this.paused) return;
        // The first card change comes 2 s after the page opens so visitors see the cards move; a hover or focus before it cancels it
        if (this.firstChangePending) {
          this.firstChangePending = false;
          this.timer = window.setTimeout(() => {
            this.next();
            this.restart();
          }, 2000);
          return;
        }
        const speed = Math.max(3, parseInt(this.dataset.speed, 10) || 6) * 1000;
        this.timer = window.setInterval(() => this.next(), speed);
      }

      stop() {
        // Timeouts and intervals share one id list, so this clears the first change timeout too
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }

      pause() {
        this.paused = true;
        this.stop();
      }

      resume() {
        this.paused = false;
        this.restart();
      }

      onBlockSelect(event) {
        const i = this.slides.findIndex((slide) => slide === event.target || slide.contains(event.target));
        this.pause();
        if (i >= 0) this.goTo(i);
      }
    }

    customElements.define('marine-hero-cards', MarineHeroCards);
  }
  } catch(e) { console.error(e); }
})();

})();
